"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityTypeCircleBarChartIcon = exports.EntityTypeCircleBarChartIconDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var entity_type_icon_1 = require("./entity-type-icon");
exports.EntityTypeCircleBarChartIconDefaultProps = {
  size: 48
};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: linear-gradient(to right, transparent, transparent 50%, ", " 50%, ", " 100%);\n    padding: 6px;\n    border-radius: 50%;\n  "], ["\n    background: linear-gradient(to right, transparent, transparent 50%, ", " 50%, ", " 100%);\n    padding: 6px;\n    border-radius: 50%;\n  "])), theme_1.theme.COLOR('primary'), theme_1.theme.COLOR('primary'))
});
var IconStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Icon: (0, styled_components_1.default)(entity_type_icon_1.EntityTypeIcon)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), IconStyles)
};
var EntityTypeCircleBarChartIcon = function (props) {
  var className = props.className,
    entityTypeName = props.entityTypeName,
    onClick = props.onClick,
    size = props.size;
  return react_1.default.createElement(My.Container, {
    className: className
  }, react_1.default.createElement(My.Icon, {
    color: "light",
    entityTypeName: entityTypeName,
    size: size - 12
  }));
};
exports.EntityTypeCircleBarChartIcon = EntityTypeCircleBarChartIcon;
exports.EntityTypeCircleBarChartIcon.defaultProps = exports.EntityTypeCircleBarChartIconDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;